import React, { useEffect } from 'react'
import CenterStage from '../../../Components/CenterStage/CenterStage'
import VideoPlayer from '../../../Components/VideoPlayer/VideoPlayer'
import imgStage from '../../../assets/ResponsibilityAndSocialCommitments/Donation/Stagew.jpg'
import SectionHeader from '../../../Components/SectionHeader/SectionHeader'
import ImageText from '../../../Components/ImageText/ImageText'
import ServiceCarousel from '../../../Components/ServiceCarousel/ServiceCarousel'
import imgCheckPresentation from '../../../assets/ResponsibilityAndSocialCommitments/Donation/CheckPresentation.jpg'
import imgHospital from '../../../assets/ResponsibilityAndSocialCommitments/Donation/Hospital.jpeg'
import imgChildrensHome from '../../../assets/ResponsibilityAndSocialCommitments/Donation/ChildrensHome.jpeg'
import imgSolidatory from '../../../assets/ResponsibilityAndSocialCommitments/Donation/Solidatory.jpg'
import imgEngineers from '../../../assets/ResponsibilityAndSocialCommitments/Donation/Engineers.jpg'
import imgBORDA from '../../../assets/ResponsibilityAndSocialCommitments/Donation/BORDA.jpg'
import imgViva from '../../../assets/ResponsibilityAndSocialCommitments/Donation/Viva.jpg'

const DonationInsteadGifts = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const data1 = {
        image: imgCheckPresentation,
        title: 'Check presentation to the Solidarity Ukraine Foundation',
        description: 'At HANSA-FLEX, it is important to us to give something back to society. We hope that the war in Ukraine will soon end, especially for children and those in particular need of help, so that we can help with concrete measures on the ground, explains Alina Armerding, co-owner of HANSA-FLEX, who is involved in the foundation as a board member. You can support the foundation directly:',
        buttonName: "More Information",
        buttonLink: 'https://stiftung-solidaritaet-ukraine.de/'
    }

    const data2 = {
        image: imgHospital,
        title: 'Hospital in Odessa',
        description: 'The medical center, 30 km from Odessa, provides primary care to around 15,000 people from three surrounding villages. It is run by two doctors. The donation of EUR 20,000 will be used to purchase new furniture and repair sanitary facilities. Structural repairs will also be carried out on the floors and the heating system.',
    }

    const data3 = {
        image: imgChildrensHome,
        title: "Children's home in Odessa",
        description: "The children's home, two hours from Odessa, cares for orphans between the ages of 5 and 16. The donation of EUR 20,000 will be used to purchase generators for electricity as well as basic equipment such as furniture, children's clothing, learning materials and toys.",
    }

    const ServiceCarouselData = [
        {
            title: "Solidarity Ukraine Foundation",
            description: "In 2022, we founded the Solidarity Ukraine Foundation together with BUHLMANN Rohr-Fittings-Stahlhandel GmbH + Co. KG. Its goal is to support the reconstruction of critical infrastructure, such as health and educational institutions in Ukraine. We donated a total of EUR 100,000 in 2022-2023.",
            imageSrc: imgSolidatory
        },
        {
            title: "Engineers Without Borders eV",
            description: "Together with local partners, Engineers Without Borders is committed to technical cooperation in establishing basic supplies of electricity, water and sanitation. Between 2017 and 2021, a total of EUR 135,000 was donated to support projects in Guinea, Tanzania and Uganda.",
            imageSrc: imgEngineers
        },
        {
            title: "BORDA eV",
            description: "To ensure access to sanitation facilities, BORDA e. V. works with partners worldwide to support the construction of water, sewage and sanitation facilities. Between 2017 and 2021, we donated a total of EUR 80,000 to support India, Bangladesh and Jordan.",
            imageSrc: imgBORDA
        },
        {
            title: "Viva with Agua de Sankt Pauli eV",
            description: "Water, sanitation and hygiene projects are the focus of Viva con Agua. The association builds drinking water and sanitation facilities with local partners around the world and holds workshops. From 2017 to 2021, we supported projects in Nepal, Uganda and Mozambique with a total of EUR 60,000.",
            imageSrc: imgViva
        }
    ];

    return (
        <div>
            <CenterStage imageSrc={imgStage} title={"DONATION INSTEAD OF GIFTS"}
                paragraph={"For several years now, HANSA-FLEX has refrained from giving promotional gifts to customers and instead donated to good causes. As in previous years, projects run by the “Solidarity Ukraine” foundation will be supported in 2024."} />

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', margin: "auto", padding: "20px" }}>
                {/* YouTube Video */}
                <VideoPlayer
                    src="https://www.youtube.com/embed/tBr0kP4DIe4?si=cSLhJhh8lmqGoJ5R"
                    width="800px"
                    height="450px"
                    autoplay={false}
                    loop={false}
                    fallbackText="Your browser does not support this video."
                    onErrorFallback="Unable to load the video. Please check the link or try another video."
                />
            </div>

            <SectionHeader title={"SUPPORTED PROJECTS 2024"} />
            <ImageText data={data1} left={true} />
            <ImageText data={data2} left={false} />
            <ImageText data={data3} left={true} />

            <SectionHeader title={"SUPPORTED PROJECTS OF THE LAST YEARS"} />
            <ServiceCarousel images={ServiceCarouselData} autoPlayInterval={5000} />
        </div>
    )
}

export default DonationInsteadGifts